import React from 'react';
import { FormattedMessage } from 'react-intl';

import Styled from 'app/features/couponCampaign/landing/components/Perks/Perks.styled';
import S from 'app/features/couponCampaign/landing/components/HeroBlock.styled';
import AdFreeAnime from 'app/features/couponCampaign/landing/components/Perks/AdFreeAnime';
import OneHourAfterJapanBroadcast from 'app/features/couponCampaign/landing/components/Perks/OneHourAfterJapanBroadcast';
import OfflineViewing from 'app/features/couponCampaign/landing/components/Perks/OfflineViewing';
import StreamOnDevices from 'app/features/couponCampaign/landing/components/Perks/StreamOnDevices';
import Heading from 'app/components/layout/Heading.styled';

const UI = () => (
  <>
    <Heading size="s" as={Styled.Title}>
      <FormattedMessage id="coupon_landing_perks_title" />
    </Heading>
    <S.PerksHolder>
      <OneHourAfterJapanBroadcast />
      <AdFreeAnime />
      <OfflineViewing />
      <StreamOnDevices />
    </S.PerksHolder>
  </>
);

UI.displayName = 'Perks';

export { UI };

export default UI;
